var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegacyEstate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "inventory",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 230",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180,26.6c-40.4,0-72.8,32.8-72.8,73.2c0,40.2,32.6,72.8,72.8,72.8c40.2,0,73-32.6,73-73C253,59.2,220.4,26.6,180,26.6z  M185.5,139.5v11.4h-10.1v-11.1c-8.7,0-17.5-2.3-21.7-4.7l3.7-14.8c4.7,2.3,12,5,19.8,5c8.4,0,12.5-3.7,12.5-8.7 c0-5-4-7.1-13.6-10.9c-13.4-4.7-21.7-11.4-21.7-23.5c0-11.1,7.3-19.8,20.8-22.5v-12h10.1v11.4c8.4,0,14.4,1.7,18.9,4.1l-4.1,14.4 c-3.3-1.4-8.7-3.7-16.1-3.7s-11.4,3.7-11.4,7.3c0,5,4.7,7,14.8,11.1c13.8,5,20.2,12,20.2,23.5C207.2,127.4,200.2,136.1,185.5,139.5z  M205.7,213c0,7-5.7,12.6-12.6,12.6h-85.8C97,225.9,85.9,222,78,214.2l-32.3-32.3c-4.1-4.1-9.4-6.2-14.7-6.2H2v-50h54v-0.1 c10,0,20,3.9,27.8,11.5l46.3,46.3c4.9,4.9,4.9,12.8,0,17.7s-12.8,4.9-17.7,0L75,163.9c-1.5-1.7-4.1-1.7-5.7,0 c-1.7,1.7-1.7,4.3,0,5.9l37.2,37.2c3.9,4.1,9.2,6.2,14.7,6.2s10.9-2.3,14.7-6.2c1.9-1.7,3.4-4.1,4.5-6.4H193 C200,200.6,205.7,206.2,205.7,213z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacyEstate);
export default __webpack_public_path__ + "static/media/legacy-estate.7e24058064d97ced90537f4c0829ff7e.svg";
export { ForwardRef as ReactComponent };